/**
 * 日時の相対表記(「今日 09:12」「3 日前」)。絶対時刻は Tooltip で出す。
 *
 * ISO をそのまま表に出すと 1280 幅で折り返す(UX1-a 低B)。文字数が安定する
 * 相対表記にして、正確な時刻は hover に逃がす。
 * `future` は期限向け(「期限まで 3 日」「2 日超過」)。超過は赤。
 */
import { Tooltip } from "antd";
import { jst } from "../lib/format";
import { relativeTime, untilTime } from "./relativeTime";

export function TimeAgo({
  iso,
  empty = "—",
  future = false,
}: {
  iso: string | null | undefined;
  empty?: string;
  /** 期限として読む(残り / 超過) */
  future?: boolean;
}) {
  if (!iso) return <span className="ui-num">{empty}</span>;
  if (future) {
    const r = untilTime(iso);
    return (
      <Tooltip title={jst(iso)}>
        <span className={`ui-num${r.over ? " ui-time-over" : ""}`}>{r.text}</span>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={jst(iso)}>
      <span className="ui-num">{relativeTime(iso)}</span>
    </Tooltip>
  );
}
